import { useEffect } from 'react';

const GA_TRACKING_ID = 'G-CJJQM27SFC';
const CLARITY_PROJECT_ID = 'svpqyf218d';

// Initialize Google Analytics
export const initGA = () => {
  if (typeof window === 'undefined') return;
  
  // Create gtag function
  window.dataLayer = window.dataLayer || [];
  function gtagFunction(){
    window.dataLayer.push(arguments);
  }
  window.gtag = gtagFunction;
  
  // Load gtag script
  const script = document.createElement('script');
  script.async = true;
  script.src = `https://www.googletagmanager.com/gtag/js?id=${GA_TRACKING_ID}`;
  document.head.appendChild(script);
  
  // Configure gtag
  window.gtag('js', new Date());
  window.gtag('config', GA_TRACKING_ID, {
    page_title: document.title,
    page_location: window.location.href,
  });
};

// Initialize Microsoft Clarity
export const initClarity = () => {
  if (typeof window === 'undefined') return;
  
  // Create Clarity function
  window.clarity = window.clarity || function() {
    (window.clarity.q = window.clarity.q || []).push(arguments);
  };
  
  // Load Clarity script
  const script = document.createElement('script');
  script.async = true;
  script.src = 'https://www.clarity.ms/tag/' + CLARITY_PROJECT_ID;
  document.head.appendChild(script);
  
  // Initialize Clarity
  window.clarity('start');
};

// Track page views
export const trackPageView = (url, title) => {
  if (typeof window !== 'undefined' && window.gtag) {
    window.gtag('config', GA_TRACKING_ID, {
      page_path: url,
      page_title: title,
    });
  }
};

// Track events
export const trackEvent = (action, category = 'general', label = '', value = 0) => {
  if (typeof window !== 'undefined' && window.gtag) {
    window.gtag('event', action, {
      event_category: category,
      event_label: label,
      value: value,
    });
  }
};

// Track custom events
export const trackCustomEvent = (eventName, parameters = {}) => {
  if (typeof window !== 'undefined' && window.gtag) {
    window.gtag('event', eventName, parameters);
  }
};

// Microsoft Clarity custom events
export const trackClarityEvent = (eventName, customData = {}) => {
  if (typeof window !== 'undefined' && window.clarity) {
    window.clarity('event', eventName, customData);
  }
};

// Set user identification for Clarity
export const setClarityUser = (userId, sessionData = {}) => {
  if (typeof window !== 'undefined' && window.clarity) {
    window.clarity('identify', userId, sessionData);
  }
};

// Defer analytics initialization until after page is interactive
// This improves FCP by not blocking initial render
const deferAnalyticsInit = (initFn) => {
  if (typeof window === 'undefined') return;

  // Use requestIdleCallback if available, otherwise setTimeout
  if ('requestIdleCallback' in window) {
    window.requestIdleCallback(() => initFn(), { timeout: 3000 });
  } else {
    setTimeout(() => initFn(), 2000);
  }
};

// Component to initialize both GA and Clarity
const Analytics = () => {
  useEffect(() => {
    // Defer analytics initialization to not block FCP
    deferAnalyticsInit(initGA);
    deferAnalyticsInit(initClarity);
  }, []);

  return null; // This component doesn't render anything
};

export default Analytics;